<template>
    <div id="songs-list">
        <h1 class="display-1 font-weight-regular">{{ $t('songs-list') }}</h1>

        <v-layout row wrap class="mt-4" v-if="!isMobile">
            <v-flex xs12>
                <v-btn color="primary" @click="$router.push('/new-song')">
                    <v-icon>music_note</v-icon>
                    {{ $t('new-song') }}
                </v-btn>
            </v-flex>
        </v-layout>

        <v-list two-line class="mt-4" v-if="songs.length > 0">
            <template v-for="(song, index) in songs">
                <v-list-tile :key="song.id" @click="showSong(song.id, false)">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="song.title"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="song.author"></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <div>
                            <v-btn icon ripple v-if="!isMobile" @click.stop="showSong(song.id, true)">
                                <v-icon color="grey lighten-1">edit</v-icon>
                            </v-btn>
                            <v-btn icon ripple class="ml-2" @click.stop="dialogDeleteSong = true; songIdToDelete = song.id">
                                <v-icon color="grey lighten-1">delete</v-icon>
                            </v-btn>
                        </div>
                    </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="index + 1 < songs.length" :key="index"></v-divider>
            </template>
        </v-list>

        <v-dialog v-model="dialogDeleteSong" max-width="400" :lazy="true" persistent>
            <v-card>
                <v-card-title class="headline">{{ $t('song-deletion') }}</v-card-title>

                <v-card-text>
                    <p class="text-xs-left">
                        {{ $t('song-delete-text') }}
                    </p>
                </v-card-text>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="dialogDeleteSong = false">{{ $t('no') }}</v-btn>
                    <v-btn color="success" flat @click.native="deleteSong()">{{ $t('yes') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import store from '@/stores';
import * as types from '@/stores/types';

export default {
    name:       'songs-list',
    store,
    data: function()
    {
        return {
            dialogDeleteSong: false,
            songIdToDelete:   null,
        };
    },
    computed: {
        ...mapGetters({
            songs:       'songs',
            editionMode: 'editionMode',
            isMobile:    'isMobile',
        }),
    },
    methods: {
        ...mapActions({
            deleteSongAction:        types.A_SONGSLIST_DELETE_SONG,
            toggleEditionModeAction: types.A_SONG_TOGGLE_EDITION_MODE,
        }),
        /**
         * Affichage d'une chanson
         *
         * @author Fabien Bellanger
         * @param {Number}  songID      ID de la chanson
         * @param {Boolean} isEdition   Edition de la chanson
        */
        showSong: function(songId, isEdition)
        {
            // On active / désactive le mode édition selon le cas
            // --------------------------------------------------
            if ((this.editionMode && !isEdition) || (!this.editionMode && isEdition))
            {
                this.toggleEditionModeAction();
            }

            this.$router.push({ name: 'edit-song', params: { id: songId } });
        },
        /**
         * Suppression d'une chanson
         *
         * @author Fabien Bellanger
         */
        deleteSong: function()
        {
            if (this.songIdToDelete !== null)
            {
                this.deleteSongAction(this.songIdToDelete);
            }

            // Fermeture de la modale
            // ----------------------
            this.dialogDeleteSong = false;
        },
    },
};
</script>
